import { render, staticRenderFns } from "./remove-technician-to-order-modal.vue?vue&type=template&id=5ca9b2b2&lang=pug"
import script from "./remove-technician-to-order-modal.vue?vue&type=script&lang=js"
export * from "./remove-technician-to-order-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports